import React from "react";
import "./KotlinHero.css";
import { NavLink } from "react-router-dom";

const KotlinHero = () => {
    return (
        <>
            <section
                style={{
                    position: "relative",
                    overflow: "hidden",
                    background:
                        "linear-gradient(180deg,#ffffff 0%,#fff5f5 45%,#ffffff 100%)",
                    padding: "130px 24px 110px",
                }}
            >

                {/* BACKGROUND */}
                <div className="kh-glow kh-glow1"></div>
                <div className="kh-glow kh-glow2"></div>

                <div className="kh-grid">

                    {/* LEFT */}
                    <div className="kh-left">

                        <div className="kh-badge">
                            🚀 KOTLIN APP DEVELOPMENT
                        </div>

                        <h1>
                            Build Powerful
                            <br />
                            <span>Kotlin Apps</span>
                            <br />
                            For Android
                        </h1>

                        <p>
                            We build modern Kotlin applications with
                            scalable architecture, blazing-fast performance,
                            smooth animations and premium Android user
                            experiences for startups and enterprises.
                        </p>

                        {/* BUTTONS */}
                        <div className="kh-btn-wrap">
                            <NavLink to="/Contactus">
                                <a href="#" className="kh-btn-primary">
                                    Start Kotlin Project →
                                </a>
                            </NavLink>
                        </div>

                        {/* STATS */}
                        <div className="kh-stats">

                            {[
                                {
                                    number: "80+",
                                    text: "Apps Delivered",
                                },
                                {
                                    number: "99%",
                                    text: "Client Satisfaction",
                                },
                                {
                                    number: "4.9★",
                                    text: "Play Store Ratings",
                                },
                            ].map((item, i) => (

                                <div
                                    key={i}
                                    className="kh-stat"
                                >

                                    <h3>{item.number}</h3>

                                    <p>{item.text}</p>

                                </div>

                            ))}

                        </div>

                    </div>

                    {/* RIGHT */}
                    <div className="kh-right">

                        <div className="kh-phone">
                            <div className="kh-phone-inner">
                                <svg
                                    viewBox="0 0 320 650"
                                    width="100%"
                                    height="100%"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <defs>
                                        <linearGradient id="phoneBg" x1="0" y1="0" x2="1" y2="1">
                                            <stop offset="0%" stopColor="#18181b" />
                                            <stop offset="100%" stopColor="#27272a" />
                                        </linearGradient>

                                        <linearGradient id="cardGradient" x1="0" y1="0" x2="1" y2="1">
                                            <stop offset="0%" stopColor="#7C3AED" />
                                            <stop offset="100%" stopColor="#A855F7" />
                                        </linearGradient>

                                        <linearGradient id="chartGradient" x1="0" y1="0" x2="1" y2="0">
                                            <stop offset="0%" stopColor="#8B5CF6" />
                                            <stop offset="100%" stopColor="#EC4899" />
                                        </linearGradient>
                                    </defs>

                                    {/* Screen */}
                                    <rect
                                        x="0"
                                        y="0"
                                        width="320"
                                        height="650"
                                        rx="40"
                                        fill="url(#phoneBg)"
                                    />

                                    {/* Notch */}
                                    <rect
                                        x="110"
                                        y="18"
                                        width="100"
                                        height="24"
                                        rx="12"
                                        fill="#09090b"
                                    />

                                    {/* Header */}
                                    <text
                                        x="30"
                                        y="90"
                                        fill="white"
                                        fontSize="28"
                                        fontWeight="700"
                                    >
                                        Kotlin
                                    </text>

                                    <text
                                        x="30"
                                        y="122"
                                        fill="#A1A1AA"
                                        fontSize="15"
                                    >
                                        Android Excellence
                                    </text>

                                    {/* Main Card */}
                                    <rect
                                        x="25"
                                        y="155"
                                        width="270"
                                        height="150"
                                        rx="28"
                                        fill="url(#cardGradient)"
                                    />

                                    <text
                                        x="45"
                                        y="200"
                                        fill="white"
                                        fontSize="22"
                                        fontWeight="700"
                                    >
                                        Performance
                                    </text>

                                    <text
                                        x="45"
                                        y="230"
                                        fill="rgba(255,255,255,.8)"
                                        fontSize="14"
                                    >
                                        Modern Android Apps
                                    </text>

                                    <circle
                                        cx="245"
                                        cy="215"
                                        r="40"
                                        fill="rgba(255,255,255,.15)"
                                    />

                                    <text
                                        x="227"
                                        y="223"
                                        fill="white"
                                        fontSize="20"
                                        fontWeight="700"
                                    >
                                        98%
                                    </text>

                                    {/* Analytics */}
                                    <rect
                                        x="25"
                                        y="340"
                                        width="270"
                                        height="120"
                                        rx="24"
                                        fill="#1F1F23"
                                    />

                                    <text
                                        x="40"
                                        y="375"
                                        fill="white"
                                        fontSize="18"
                                        fontWeight="600"
                                    >
                                        User Growth
                                    </text>

                                    <path
                                        d="M45 430
           C90 390 120 450 170 400
           C220 350 240 390 280 360"
                                        fill="none"
                                        stroke="url(#chartGradient)"
                                        strokeWidth="6"
                                        strokeLinecap="round"
                                    />

                                    {/* Bottom Stats */}
                                    <rect
                                        x="25"
                                        y="495"
                                        width="125"
                                        height="95"
                                        rx="22"
                                        fill="#1F1F23"
                                    />

                                    <text
                                        x="45"
                                        y="535"
                                        fill="#A855F7"
                                        fontSize="24"
                                        fontWeight="700"
                                    >
                                        4.9★
                                    </text>

                                    <text
                                        x="45"
                                        y="565"
                                        fill="#A1A1AA"
                                        fontSize="13"
                                    >
                                        App Rating
                                    </text>

                                    <rect
                                        x="170"
                                        y="495"
                                        width="125"
                                        height="95"
                                        rx="22"
                                        fill="#1F1F23"
                                    />

                                    <text
                                        x="190"
                                        y="535"
                                        fill="#22C55E"
                                        fontSize="24"
                                        fontWeight="700"
                                    >
                                        1M+
                                    </text>

                                    <text
                                        x="190"
                                        y="565"
                                        fill="#A1A1AA"
                                        fontSize="13"
                                    >
                                        Downloads
                                    </text>
                                </svg>
                            </div>
                        </div>

                    </div>

                </div>
            </section>
        </>
    );
};

export default KotlinHero;